export enum StatusCodes {
  InIt = 0,
  Success = 200,
  BadRequest = 400,
  Unauthorized = 401,
  InvalidRezClient = 402,
  NotFound = 404,
  AtlasValidationError = 405,
  TenantNotFound = 406,
  InvalidReservationType = 407,
  InvalidOrNullDate = 408,
  InvalidRateCombination = 409,
  AppointmentCapReached = 410,
  CustomerIsRequired = 411,
  InvalidDateRange = 412,
  DateRangeExceeded = 413,
  InvalidCountryCode = 415,
  RentalTypeMustHaveRateSet = 416,
  InvalidNotificationType = 417,
  InternalServerError = 500
}

export enum AgreementTypeEnum {
  Loaner = 1,
  Rental = 8,
  Loyalty = 7,
  Subscription = 12,
  TestDrive = 9
}
